import React from "react"
import styled from "styled-components"

const Title = ({ title, subtitle, className }) => {
  return (
    <Container className={className}>
      <h2>{title}</h2>
      <h3>{subtitle}</h3>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 3rem;
  h2 {
    text-transform: uppercase;
    margin-bottom: 0.75rem;
  }
  h3 {
    text-transform: uppercase;
    color: var(--grey-500);
    max-width: 300px;
    @media (min-width: 768px) {
      max-width: max-content;
    }
    &:after {
      content: "";
      background: var(--primary-500);
      display: block;
      height: 7px;
      width: 200px;
      margin: 20px auto -20px;
    }
  }
`

export default Title
